import { useEffect, useState } from "react";
import { Mail, MessageCircle, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Panel, Tone } from "@/components/shared";
import { api, errMsg, useApi } from "@/lib/api";

const SECTIONS = [
  { key: "smtp", title: "SMTP email", icon: Mail, fields: [["host", "Host"], ["port", "Port"], ["username", "Username"], ["password", "Password", "secret"], ["fromEmail", "From email"]] },
  { key: "whatsapp", title: "WhatsApp gateway", icon: MessageCircle, fields: [["apiToken", "API token", "secret"], ["phoneNumberId", "Phone number ID"]] },
  { key: "shopify", title: "Shopify", icon: ShoppingBag, fields: [["storeDomain", "Store domain (xxx.myshopify.com)"], ["accessToken", "Admin API access token", "secret"], ["webhookSecret", "Webhook secret", "secret"]] },
];

function Section({ s, initial, onSaved }) {
  const [f, setF] = useState(initial);
  const save = async () => {
    try { await api.put(`/settings/integrations/${s.key}`, f); toast.success(`${s.title} saved`); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel title={<span className="flex items-center gap-2"><s.icon className="h-4 w-4" />{s.title}</span>}
      action={initial.configured ? <Tone tone="green">Configured</Tone> : <Tone tone="gray">Not configured</Tone>} data-testid={`integration-${s.key}`}>
      <div className="p-5 grid sm:grid-cols-2 gap-4">
        {s.fields.map(([k, l, type]) => (
          <div key={k} className="space-y-1.5"><Label>{l}</Label>
            <Input type={type === "secret" ? "password" : "text"} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })}
              onFocus={(e) => type === "secret" && e.target.value.startsWith("••") && setF({ ...f, [k]: "" })} data-testid={`${s.key}-${k}-input`} />
          </div>
        ))}
        <div className="sm:col-span-2"><Button size="sm" onClick={save} data-testid={`save-${s.key}-button`}>Save {s.title}</Button></div>
      </div>
    </Panel>
  );
}

export function IntegrationsTab() {
  const { data, reload } = useApi("/settings/integrations");
  const [key, setKey] = useState(0);
  useEffect(() => setKey((k) => k + 1), [data]);
  if (!data) return null;
  return (
    <div className="grid xl:grid-cols-2 gap-6" key={key}>
      {SECTIONS.map((s) => <Section key={s.key} s={s} initial={data[s.key]} onSaved={reload} />)}
      <p className="xl:col-span-2 text-xs text-muted-foreground">Secrets are stored server-side and shown masked. Shopify credentials saved here take priority over the server environment and switch sync to live mode.</p>
    </div>
  );
}
